export const Bio = {
  name: "Bala Ganesh",
  roles: [
    "Software Developer",
    "Creative Problem Solver",
    "Tech Enthusiast",
  ],
  description:
    "Enthusiastic software developer with a strong foundation in programming and software development. I am dedicated to contributing to innovative projects and eager to apply my skills to make a meaningful impact.",
  github: "https://github.com/Bala-Ganesh-444",
  resume:
    "https://drive.google.com/file/d/1kPHe84koDQzsGIiPhcQhCSF304uuWimR/view?usp=sharing",
  linkedin: "https://www.linkedin.com/",
  image: "https://avatars.githubusercontent.com/u/253491242?v=4",
};
export const skills = [
  {
    title: "Programming Languages",
    skills: [
      { name: "Java", image: "https://skillicons.dev/icons?i=java" },
      { name: "Python", image: "https://skillicons.dev/icons?i=py" },
      { name: "C", image: "https://skillicons.dev/icons?i=c" },
      { name: "C++", image: "https://skillicons.dev/icons?i=cpp" },
    ],
  },
  {
    title: "Frontend Architecture",
    skills: [
      { name: "HTML", image: "https://skillicons.dev/icons?i=html" },
      { name: "CSS", image: "https://skillicons.dev/icons?i=css" },
      { name: "JavaScript", image: "https://skillicons.dev/icons?i=js" },
      { name: "React", image: "https://skillicons.dev/icons?i=react" },
      { name: "Bootstrap", image: "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png" },
      { name: "Three.js", image: "https://threejs.org/files/favicon.ico" },
    ],
  },
  {
    title: "Backend & Database",
    skills: [
      { name: "Node.js", image: "https://skillicons.dev/icons?i=nodejs" },
      { name: "PHP", image: "https://skillicons.dev/icons?i=php" },
      { name: "MySQL", image: "https://skillicons.dev/icons?i=mysql" },
      { name: "MongoDB", image: "https://skillicons.dev/icons?i=mongo" },
      { name: "PostgreSQL", image: "https://skillicons.dev/icons?i=postgres" },
      { name: "Oracle", image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/oracle/oracle-original.svg" },
      { name: "XAMPP", image: "https://i.pinimg.com/736x/5c/3d/4b/5c3d4b018e0995b97171a35e06da9dae.jpg" },
    ],
  },
  {
    title: "Ecosystem & DevOps",
    skills: [
      { name: "Git", image: "https://skillicons.dev/icons?i=git" },
      { name: "GitHub", image: "https://skillicons.dev/icons?i=github" },
      { name: "VS Code", image: "https://skillicons.dev/icons?i=vscode" },
      { name: "Docker", image: "https://skillicons.dev/icons?i=docker" },
      { name: "Postman", image: "https://skillicons.dev/icons?i=postman" },
      { name: "Linux", image: "https://skillicons.dev/icons?i=linux" },
      { name: "Figma", image: "https://skillicons.dev/icons?i=figma" },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: require("../images/smack.png"),
    role: "Associate Software Engineer",
    organization: "Smackcoders Inc.",
    date: "Dec 2025 - Present",
    desc: "Working as a software engineering intern, gaining hands-on experience in full-stack web development and contributing to modern application architectures.",
    skills: [
      "Software Development",
      "Web Applications",
      "JavaScript",
      "React",
      "Node.js"
    ],
  },
  {
    id: 1,
    img: require("../images/aa.png"),
    role: "Web Developer",
    organization: "Bewyvise Network Limited, Tirunelveli",
    date: "09/2025 - 10/2025",
    desc: "Built a responsive luxury automotive concept website for Jaguar. Developed a full-stack architecture to seamlessly process and store customer feedback and inquiries directly into a MongoDB system.",
    skills: [
      "HTML",
      "CSS",
      "MongoDB",
      "Full-Stack Development",
      "Responsive Design"
    ],
  }
];


export const education = [
  {
    id: 0,
    img: require("../images/Ms_logo.png"),
    school: "Manonmaniam Sundaranar University",
    date: "June 2024 - June 2026",
    grade: "",
    desc: "I am pursuing my Master's degree in MCA at Manonmaniam Sundaranar University, Tirunelveli.I have completed 3 semesters and am eager to apply my growing knowledge in programming and software development.",
    degree: "Master of Computer Applications",
  },
  {
    id: 1,
    img: require("../images/Sadak logo.png"),
    school: "Sadakathulla Appa College",
    date: "June 2021 - June 2024",
    grade: "8.2/10 CGPA",
    desc: "I Completed my Bachelor's degree in Computer Science at Sadakathulla Appa College, Tirunelveli.",
    degree: "Bachelor of Science, Computer Science",
  },
  {
    id: 2,
    img: require("../images/schaffter-higher-secondary-school-tirunelveli-logo.png"),
    school: "Schaffter Higher Secondary School",
    date: "June 2020",
    grade: "92.6%",
    desc: "I completed my class 12 education at Schaffter Higher Secondary School in Tirunelveli, specializing in Computer Science.",
    degree: "Class 12, Computer Science",
  },
];

export const projects = [
  {
    id: 1,
    title: "Skill Forge - Ai Resume Analyzer",
    date: "Mar 2026",
    description:
      "Skill Forge is an tool that helps job seekers improve their resumes for targeted roles. It uses Natural Language Processing (NLP) to compare resumes with job descriptions, identifying skill gaps and keyword mismatches. The tool provides a match score and personalized feedback to boost resume alignment and increase interview chances.",
    image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
    tags: ["Python", "NLP", "AI", "Machine Learning"],
    category: "machine learning",
    github: "https://github.com/Bala-Ganesh-444/Skill-Forge---Ai-Resume-Analyzer",
    webapp: "https://github.com/Bala-Ganesh-444/Skill-Forge---Ai-Resume-Analyzer"
  },
  {
    id: 2,
    title: "Jaguar Concept Website & Feedback System",
    date: "Mar 2026",
    description:
      "A responsive, multi-page website built for a luxury automotive brand (Jaguar), featuring a comprehensive model showcase, brand heritage narrative, and a functional contact form. Utilizes a full-stack architecture to process and store customer inquiries and test-drive requests directly into a MongoDB database.",
    image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
    tags: ["HTML", "CSS", "MongoDB", "Full-Stack"],
    category: "web app",
    github: "https://github.com/Bala-Ganesh-444/Jaguar-Concept-Website-Customer-Feedback-System",
    webapp: "https://github.com/Bala-Ganesh-444/Jaguar-Concept-Website-Customer-Feedback-System"
  },
  {
    id: 3,
    title: "Bala-Ganesh-444 Profile",
    date: "Mar 2026",
    description:
      "A tailored GitHub profile README providing an engaging introduction, highlighting personal statistics, top languages, and integrating visual metrics like a pac-man contribution graph to make the profile unique and professional.",
    image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
    tags: ["Markdown", "GitHub Profile", "Open Source"],
    category: "profile",
    github: "https://github.com/Bala-Ganesh-444/Bala-Ganesh-444",
    webapp: "https://github.com/Bala-Ganesh-444/Bala-Ganesh-444"
  }
];


export const TimeLineData = [
  { year: 2020, text: "Completed Class 12 in Computer Science at Schaffter Higher Secondary School" },
  { year: 2021, text: "Started B.Sc in Computer Science at Sadakathulla Appa College" },
  { year: 2024, text: "Graduated with B.Sc and commenced Master of Computer Applications (MCA) at MSU" },
  { year: 2025, text: "Worked as a Web Developer at Bewyvise Network, developing the Jaguar Concept site" },
  { year: 2025, text: "Joined Smackcoders Inc. as an Associate Software Engineer Intern" },
  { year: 2026, text: "Developed Skill Forge - AI Resume Analyzer" },
];
